<template>
  <div>
    <v-list dense v-for="item in items" v-bind:key="item" class="py-0">
      <v-list-item>
        <v-checkbox
          dense
          v-model="selectedItems"
          :label="item"
          :value="item"
          hide-details="auto"
        />
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import Vue from "vue"

export default Vue.extend({
  components: {},
  data() {
    return {
      items: [],
      selectedItems: [],
      valueGetter: null,
    }
  },
  methods: {
    isFilterActive() {
      return !!this.selectedItems.length
    },

    doesFilterPass(params) {
      return (
        !this.selectedItems.length ||
        this.selectedItems.some(selectedItem => {
          const value = this.valueGetter(params.node)
          return value && value.toString().indexOf(selectedItem) >= 0
        })
      )
    },

    // getModel() {},
    // setModel(model) {},
    // afterGuiAttached() {},
    // componentMethod(message) {},
  },
  beforeMount() {
    this.items = this.params.colDef.filterItems
  },
  watch: {
    selectedItems: function(val, oldval) {
      if (val.length !== oldval.length) {
        this.params.filterChangedCallback()
      }
    },
    text: function(val, oldVal) {
      if (val !== oldVal) {
        this.params.filterChangedCallback()
      }
    },
  },
  created() {
    this.valueGetter = this.params.valueGetter
  },
})
</script>

<style scoped />
